exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".methodTableControl[data-v-1666bb6c] {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n}\n.methodTableControl h3[data-v-1666bb6c] {\n  margin: 0;\n}\n.methodList[data-v-1666bb6c] {\n  grid-row: span 2;\n  align-self: flex-start;\n}\n.text-align-right[data-v-1666bb6c] {\n  text-align: right;\n}", ""]);

// exports
